import NamedDto from 'modules/base/dto/NamedDto';

export class Lummus2ModelInputAttributeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.title = null;
		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.value = null;
		/** @type {string} */
		this.code = null;
		/** @type {string} */
		this.unitOpCode = null;
		/** @type {string} */
		this.uom = null;
		/** @type {string} */
		this.minValue = null;
		/** @type {string} */
		this.maxValue = null;
		/** @type {number} */
		this.orderIndex = null;
	}

	/**
	 * @typedef {Object} _Lummus2ModelInputAttributeEditDtoProps
	 * @property {string} title
	 * @property {string} type
	 * @property {string} value
	 * @property {string} code
	 * @property {string} unitOpCode
	 * @property {string} uom
	 * @property {string} minValue
	 * @property {string} maxValue
	 * @property {number} orderIndex
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _Lummus2ModelInputAttributeEditDtoProps} Lummus2ModelInputAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {Lummus2ModelInputAttributeEditDtoProps} props
	 * @returns {Lummus2ModelInputAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.title = props.title;
		this.type = props.type;
		this.value = props.value;
		this.code = props.code;
		this.unitOpCode = props.unitOpCode;
		this.uom = props.uom;
		this.minValue = props.minValue;
		this.maxValue = props.maxValue;
		this.orderIndex = props.orderIndex;
		return this;
	}
}

export default Lummus2ModelInputAttributeEditDto;
